import React from 'react'

import { formatDate } from './../utils'

const DetailsProcesso = props => {
  const { detalhes, finalizado } = props

  return (
    <div>
      <div className='juridico-detalhes-card'>
        <div className='juridico-detalhes-label'>Foro / câmara</div>
        <div className='juridico-detalhes-value'>{detalhes?.comarca}</div>
      </div>

      <div className='juridico-detalhes-card'>
        <div className='juridico-detalhes-label'>Data de Início</div>
        <div className='juridico-detalhes-value'>
          {detalhes?.dataInicio
            ? formatDate(new Date(detalhes.dataInicio))
            : '-'}
        </div>
      </div>

      <div className='juridico-detalhes-card'>
        <div className='juridico-detalhes-label'>Data de Fim</div>
        <div className='juridico-detalhes-value'>
          {detalhes?.dataFim ? formatDate(new Date(detalhes.dataFim)) : '-'}
        </div>
      </div>

      <div className='d-flex'>
        <div className='juridico-detalhes-card p-2'>
          <div className='juridico-detalhes-label'>Status Processual</div>
          <div className='juridico-detalhes-value'>
            {detalhes?.statusProcessual}
          </div>
        </div>
        <div className='juridico-detalhes-card p-2'>
          <div className='juridico-detalhes-label'>Finalizado</div>
          <div className='juridico-detalhes-value'>
            {finalizado ? 'SIM' : 'NÃO'}
          </div>
        </div>
      </div>
    </div>
  )
}

export default DetailsProcesso
